import React, { useEffect } from 'react';
import { Routes, Route, Navigate, useParams,useNavigate, useLocation } from 'react-router-dom';

import AuthedRoute from 'hoc/AuthedRoute';
import DashboardPage from 'components/dashboard/DashboardPage';
import UnauthorisedAccessPage from 'pages/UnauthorisedAccessPage';
import JobPageContainer from 'components/jobs/JobPageContainer';
import JobDetailsCreatePageContainer from 'components/jobdetails/JobDetailsCreatePageContainer';
import JobDetailsEditPageContainer from 'components/jobdetails/JobDetailsEditPageContainer';
import SearchPageContainer from 'components/search/SearchPageContainer';
import TechnicianListPage from 'components/technicians/TechnicianListPage';
import TechnicianPage from 'components/technicians/TechnicianPage';
import ContactsListPage from 'components/contacts/ContactsListPage';
import ContactPage from 'components/contacts/ContactPage';
import ClientListPageContainer from 'components/clients/ClientListPageContainer';
import AreasListPage from 'components/locations/AreasListPage';
import LocationsListPage from 'components/locations/LocationsListPage';
import LocationEditPage from 'components/locations/LocationEditPage';
import VesselsListPage from './vessels/VesselsListPage';
import VesselsPageContainer from './vessels/VesselsPageContainer';
import CubsListPage from './cubs/CubsListPage';
import CubPage from './cubs/CubPage';


const DashboardWrapper = () => {
  const navigate = useNavigate();
  const { state, page, sort } = useParams();


  useEffect(() => {
    // Your navigation logic here
    // For example, if you want to redirect to a specific page or sort
    if (!state) {
      // Handle cases where state is not defined (if needed)
      navigate('/'); // Redirect to home or another route
    } else {
      // Additional logic if necessary
      console.log(`Current state: ${state}, Page: ${page}, Sort: ${sort}`);
    }
  }, [navigate, state, page, sort]);

  return <DashboardPage />; // Render the DashboardPage component
};

const AppRoutes = (props,{location}) => {
  const { AdminGroupName, OperationsGroupName, ComplianceGroupName } = window.env;
  const adminSecurityRoles = [
    AdminGroupName,
    OperationsGroupName,
    ComplianceGroupName,
  ];
  const defaultSortParams = 'modifieddate,DESC';
  //const location = useLocation();



  return (
    <Routes>
      <Route path="/" element={<Navigate to="/dashboard/new/" />} />
      <Route path="/dashboard" element={<Navigate to="/dashboard/new/" />} />
      <Route  path="/dashboard/:state"  element={(<Navigate to={`/dashboard/new/1/${defaultSortParams}`} />
  )}
/>
      <Route path="/dashboard/:state/:page/:sort"  element={<DashboardPage location={location}/>} />
      <Route path="/jobs/:id" element={<JobPageContainer />} />
      <Route path="/jobs/details/create/:id" element={<JobDetailsCreatePageContainer />} />
    <Route path="/jobs/details/edit/:id" element={<JobDetailsEditPageContainer />} />
      <Route path="/search" element={<SearchPageContainer />} />
     <Route path="/cubs" element={<AuthedRoute roles={adminSecurityRoles} element={<CubsListPage />} />} />
      <Route path="/cubs/:action/:id?" element={<AuthedRoute roles={adminSecurityRoles} element={<CubPage />} />} />
      <Route path="/technicians" element={<AuthedRoute roles={adminSecurityRoles} element={<TechnicianListPage />} />} />
      <Route path="/technicians/:action/:id?" element={<AuthedRoute roles={adminSecurityRoles} element={<TechnicianPage />} />} />
      <Route path="/areas" element={<AuthedRoute roles={adminSecurityRoles} element={<AreasListPage />} />} />
      <Route path="/areas/:areaid" element={<AuthedRoute roles={adminSecurityRoles} element={<LocationsListPage />} />} />
      <Route path="/areas/:areaid/:action" element={<AuthedRoute roles={adminSecurityRoles} element={<LocationEditPage />} />} />
      <Route path="/areas/:areaid/:action/:locationid" element={<AuthedRoute roles={adminSecurityRoles} element={<LocationEditPage />} />} />
      <Route path="/contacts" element={<AuthedRoute roles={adminSecurityRoles} element={<ContactsListPage />} />} />
      <Route path="/contacts/:action/:id?" element={<AuthedRoute roles={adminSecurityRoles} element={<ContactPage />} />} />
      <Route path="/vessels" element={<AuthedRoute roles={adminSecurityRoles} element={<VesselsListPage />} />} />
      <Route path="/vessels/:action/:id?" element={<AuthedRoute roles={adminSecurityRoles} element={<VesselsPageContainer />} />} />
      <Route path="/clients" element={<Navigate to="/clients/1/" />} />
      <Route path="/clients/:page" element={<AuthedRoute roles={adminSecurityRoles} element={<ClientListPageContainer />} />} />
      <Route path="/401" element={<UnauthorisedAccessPage />} />
    </Routes>
  );
};

export default AppRoutes;
